import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccount from './account.reducer';

export const selectAccountState =
  createFeatureSelector<fromAccount.AccountState>(
    fromAccount.accountFeatureKey
  );

export const selectAccounts = createSelector(
  selectAccountState,
  state => state
);

export const selectAccountById = (id: string) =>
  createSelector(selectAccountState, state => ({
    ...state,
    account: state.accounts.find(account => account.id === id) ?? null,
  }));

export const selectAccountsByOwnerIds = (agencyIds: string[]) =>
  createSelector(selectAccountState, state => ({
    ...state,
    accounts: state?.accounts?.filter(
      account => account.owner?.id && agencyIds.includes(account.owner.id)
    ),
  }));

export const selectSelectedAccount = createSelector(
  selectAccountState,
  state => state.account
);
